import { formatDatetime } from '../../utils/common';
import { TableBody, TableCell, TableRow } from '@material-ui/core';
import { makeStyles, withStyles, createStyles } from '@material-ui/core/styles';
import { TPictureLog } from '../../types/cloudStorage/CloudFileList';

type TProps = {
  log: TPictureLog;
};

export const LogList = (props: TProps) => {
  const classes = useStyles();

  //資料ログ一覧
  const { log } = props;

  return (
    <>
      <TableBody>
        <StyledTableRow className='click_table_row'>
          <StyledTableCell
            className={classes.table1}
            style={{ minWidth: 60 }}
            align='center'
          >
            {log.created_name}
          </StyledTableCell>
          <StyledTableCell
            className={classes.table1}
            style={{ minWidth: 60 }}
            align='center'
          >
            {formatDatetime(new Date(log.created_at), 'YYYY/MM/DD HH:MM:SS')}
          </StyledTableCell>
          <StyledTableCell
            className={classes.table1}
            style={{ minWidth: 90 }}
            align='center'
          >
            {log.construct_name}
          </StyledTableCell>
          <StyledTableCell
            className={classes.table1}
            style={{ minWidth: 90 }}
            align='center'
          >
            {log.action_type == 'insert' && '作成'}
            {log.action_type == 'update' && '更新'}
            {log.action_type == 'delete' && '削除'}
            {log.action_type == 'download' && 'ダウンロード'}
            {log.action_type == 'create' && '共有作成'}
            {log.action_type == 'cancel' && '共有削除'}
            {log.action_type == 'edit' && '共有更新'}
          </StyledTableCell>
          <StyledTableCell
            className={classes.table1}
            style={{ minWidth: 60 }}
            align='center'
          >
            {log.picture_folder_name}
          </StyledTableCell>
          <StyledTableCell
            className={classes.table1}
            style={{ minWidth: 60 }}
            align='center'
          >
            {log.file_name}
          </StyledTableCell>
          {/* <StyledTableCell
            className={classes.table1}
            style={{ minWidth: 60 }}
            align="right"
          >
            {log.description}
          </StyledTableCell> */}
        </StyledTableRow>
      </TableBody>
    </>
  );
};

// ----------スタイル----------------

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 16
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    }
  }
}))(TableRow);

const useStyles = makeStyles(() =>
  createStyles({
    table1: {
      padding: 8
    }
  })
);
